import styled from 'styled-components'

export const Title = styled.h1`
    font-size: ${props => props.size || '#40px'};
    color: ${props => props.color || '#fff'};
    font-weight: ${props => props.weight || '400'};
    text-transform: ${props => props.transform || "none"};
    margin-top: ${props => props.marginTop || 0};
    text-align: ${props => props.align || 'left'};
    line-height: ${props => props.lineHeight || 'normal'};
    padding: ${props => props.padding || '0'};
    text-shadow: ${props => props.borderText ? '1px 2px 3px #000' : ''};
`
export const GreenTitle = styled.span`
    font-size: ${props => props.size || '#40px'};
    color: ${props => props.color || '#58b711'};
    font-weight: ${props => props.weight || '400'};
    text-transform: ${props => props.transform || "none"};
    margin-top: ${props => props.marginTop || 0};    
`

export const LinkItem = styled.p`
    font-size: ${props => props.size || "16px"};
    color: #fff;
    font-weight: 600;
    text-transform: captalize;
    display: inline;
    padding: 0 2vw 0 2vw;
    border-left: ${props => props.borderLeft || 0};
    text-shadow: ${props => props.borderText ? '1px 2px 3px #000' : ''};
`

export const Text = styled.p`
    font-size: ${props => props.size || "16px"};
    color: ${props => props.color || '#fff'};
    font-weight: ${props => props.weight || '400'};
    text-transform: ${props => props.transform || "none"};
    text-align: ${props => props.align || "left"};
    line-height: ${props=>props.lineHeight || "normal"};
    margin-top: ${props => props.marginTop || 0};
    padding: ${props => props.padding || 0};
`

export const GreenText = styled.span`
    font-size: ${props => props.size || "16px"};
    color: ${props => props.color || '#58b711'};
    font-weight: ${props => props.weight || '400'};
    text-transform: ${props => props.transform || "none"};
    text-align: ${props => props.align || "justify"};
    line-height: ${props=>props.lineHeight || "normal"}
`

export const Input = styled.input`
    max-width: 150px;
    max-height: 40px;
    width: ${props => props.width || "100%"};
    height: 100%;
    background-color: #fff;
    border: 0;
    border-radius: 5px;
    padding: 5px;
`

export const Button = styled.button`
    max-width: ${props => props.width || '60px'}; max-height: ${props => props.height || '60px'};
    width: ${props => props.width || "100%"}; 
    height: ${props => props.height || "100%"}; 
    background-color: ${props => props.color};
    border: ${props => props.border || 0};
    border-radius: ${props => props.radius || '5px'};
    padding: ${props => props.padding || "5px"};
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    background-position: center;
    transition: background 0.8s;
    color: ${props => props.textColor|| "white"}
`

export const Divider = styled.div`
    width: ${props => props.width || 0}
    height: ${props => props.height || 0}
    background-color: ${props => props.color || 'none'}
`

export const InputContato = styled.input`
    border: ${props => props.border || 'solid #58b711' };
    border-width: ${ props => props.BorderWidth || '1px'};
    background-color: ${ props => props.backgroundColor || '#fff'};
    font-size: ${ props => props.fontSize || '2vh'};
    padding: ${props => props.padding || '1vh 1vw'}
    width: ${ props => props.width || '60vw'}
    height: ${ props => props.height || '7vh'}
    border-radius: ${props => props.borderRadius || '10px'}
    margin-bottom: ${props => props.marginBottom || '2vh'}
`

export const SelectContato = styled.select`
    border: ${props => props.border || 'solid #58b711' };
    border-width: ${ props => props.BorderWidth || '1px'};
    background-color: ${ props => props.backgroundColor || '#fff'};
    font-size: ${ props => props.fontSize || '2vh'};
    padding: ${props => props.padding || '2vh 1vw'}
    width: ${ props => props.width || '62.06vw'}
    height: ${ props => props.height || '7vh'}
    margin-bottom: ${props => props.marginBottom || '2vh'}
    border-radius: ${props => props.borderRadius || '10px'}
`

export const SlidePortifolio = styled.div`
    height: 90vh !important;
    width: 100vw !important;
`

export const ClientBox = styled.div`
    height: ${props => props.height || "46vh !important"};
    width: ${props => props.width || "18vw !important"};  
    border-radius: 10px;
    border-color: transparent;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 0px 6px #22222285;
    margin: 3vh 2vw;
    background-color: #f2f2f2
`

export const ServiceImageBox = styled.div`
    border: 1px solid #22222290;
    border-radius: 5px;
    background-color: transparent;
    width: ${props => props.width || "15vw !important"}; 
    cursor: ${props => props.cursor || "auto"}; 
    height: 21vh;
    margin-top: 2vh;
`

export const ServiceBox = styled.div`
    border: 1px solid #22222260;
    border-radius: 7px;
    width: ${props => props.width || "12vw"};
    cursor: ${props => props.cursor || "auto"}; 
    color: #222;
    background-color: transparent;
    opacity: 0.7;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1vh 0;
`

export const TextClient = styled.p`
    font-size: ${props => props.size || "16px"};
    color: ${props => props.color || '#fff'};
    font-weight: ${props => props.weight || '400'};
    text-transform: ${props => props.transform || "none"};
    text-align: ${props => props.align || "left"};
    line-height: ${props=>props.lineHeight || "normal"};
    margin-top: ${props => props.marginTop || "1vh"};
    padding: ${props => props.padding || 0};
`

export const TextService = styled.p`
    font-size: ${props => props.size || "16px"};
    color: ${props => props.color || '#fff'};
    font-weight: ${props => props.weight || '400'};
    text-transform: ${props => props.transform || "none"};
    text-align: ${props => props.align || "left"};
    line-height: ${props=>props.lineHeight || "normal"};
    margin-top: ${props => props.marginTop || 0};
    padding: ${props => props.padding || 0};
    border-bottom: solid 1px #00000040;
`